import { render } from "./AdSetDetails.vue?vue&type=template&id=87c1e6ca&scoped=true"
import script from "./AdSetDetails.vue?vue&type=script&lang=js"
export * from "./AdSetDetails.vue?vue&type=script&lang=js"

import "./AdSetDetails.vue?vue&type=style&index=0&id=87c1e6ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c1e6ca"]])

export default __exports__